/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-08T09:34:20+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:52:27+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import buttonProps from './../../../utilities/buttonProps';

/**
 * AButtonIconCalendar - just a icon as button
**/
class AButtonIconCalendar extends Component {
  /**
     * react render() <AButtonIconCalendar>
     *
     * @return {object}
     */
  render() {
    const {
      onPress,
      visualState,
      icon,
      children = icon,
      style,
    } = this.props;
    return (
      <a className={`a-button a-button-icon-calendar ${visualState}`} style={style} onClick={onPress}>
        <div className="a-button-icon-calendar__flex">
          <span className={`a-icon a-button-icon-small__icon glyphicons glyphicons-${children}`} />
        </div>
      </a>
    );
  }
}

AButtonIconCalendar.propTypes = {
  onPress: PropTypes.func,
  visualState: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.string,
  style: PropTypes.object,
};
AButtonIconCalendar.defaultProps = {
  icon: 'search',
};
export default buttonProps(AButtonIconCalendar);

